import React, { FC } from 'react';

import { addWithConfig } from '@rbilabs/universal-components';
import { Typography, TypographyProps } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';

import { StyledRewardPointCost } from './reward-point-cost.styled';

export interface IRewardPointCost extends TypographyProps {
  pointCost: number;
  usePrimaryColor?: boolean;
}

const RewardPointCostText: FC<React.PropsWithChildren<IRewardPointCost>> = ({
  pointCost,
  usePrimaryColor,
  children,
  ...textProps
}) => {
  return pointCost === 0 ? (
    <StyledRewardPointCost usePrimaryColor={usePrimaryColor} {...textProps}>
      {t('free').toLocaleLowerCase()}
    </StyledRewardPointCost>
  ) : (
    <Typography {...textProps}>{children}</Typography>
  );
};

export const RewardPointCost = addWithConfig(RewardPointCostText);
